<section class="health-record-wrapper general-wrapper enable-wellness">
	<div class="container">
		<div class="row">
			<div class="col-md-12 g-right">
				<app-digital-banner></app-digital-banner>
				<div class="row">
					<div class="reports-section col-md-6">
						<div class="heading">Reports</div>
						<div *ngIf="biometricResult.length > 0">
							<p class="mb-0">You can access your biometric screening results below.</p>
							<p>Click on the year of the report to view the lab results.</p>
						</div>
						<div class="year-section">
							<ng-container *ngFor="let record of recordGroup; let currentSection = index">
								<div
									class="year {{ activeSection === currentSection ? 'active' : '' }}"
									(click)="setActiveSection(currentSection)">
									{{ record?.year }}
								</div>
							</ng-container>
						</div>
						<div class="record-section" *ngFor="let document of recordForSelectedYear; let currentRecord = index">
							<a>
								<div
									class="record-content"
									*ngIf="!(document?.documentName.toLowerCase() === catapultReport.toLowerCase())">
									<p
										class="record-name"
										(click)="openPDF(document)"
										appEheAnalytics
										[data]="{
											pageUrl: '/wellness/health/record/view',
											componentName: 'HealthRecords',
											id: getReportId(document)
										}">
										{{ document?.documentName }} - {{ getDate(document?.contextDate, 'MMM YYYY') }}
									</p>
									<!-- <span class="record-date">{{getDate(document?.contextDate, 'MMM DD, YYYY')}}</span> -->
								</div>
							</a>
							<div *ngIf="document?.documentName.toLowerCase() === catapultReport.toLowerCase()" class="record-content">
								<span [translate]="'wellness.health-record.navigation.virtual-results'">Pulse™ Virtual Results:</span>
								<a class="link" target="_blank" href="https://portal.catapulthealth.com/login"
									>Sign in to Catapult Health to view</a
								>
							</div>
						</div>
						<div class="record-section">
							<a class="link" (click)="releaseRecords()" *ngIf="!noRecords">
								<div class="record-content">Share my Medical Records</div>
							</a>
						</div>
					</div>
					<div class="consents-section col-md-6" *ngIf="!noRecords">
						<div class="heading">Consents</div>
						<ng-container *ngFor="let release of recordReleaseList">
							<div class="release-name">
								<a class="record-name link" [href]="release?.reportUrl" target="_blank">{{ release?.reportName }}</a>
							</div>
						</ng-container>
					</div>
				</div>
				<div class="text-center" *ngIf="noRecords && !biometricNotEligible">No records to display</div>
				<div *ngIf="biometricNotEligible">
					<strong>We cannot verify your Social Security number.</strong>
					<p>
						To access all your health documents, please call 800.362.8671 or email MemberServices&#64;ehe.health for
						assistance.
					</p>
				</div>
			</div>
		</div>
	</div>
</section>
<app-ehe-spinner></app-ehe-spinner>
